import React from 'react';
import { Text } from 'react-native';

/**
 * @returns an empty space to be used in the middle of text.
 */
export const TextSpace = () => {
  return <Text> </Text>;
};
